/**
=========================================================
* Material Dashboard 2 PRO React TS - v1.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-2-pro-react-ts
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

const form = {
  formId: 'new-user-form',
  formField: {
    fullName: {
      name: 'fullName',
      label: 'Full name',
      errorMsg: 'Full name is required.',
      invalidMsg: 'Full name is required.',
      type: 'text',
    },
    email: {
      name: 'email',
      label: 'Email Address',
      type: 'email',
      errorMsg: 'Email address is required.',
      invalidMsg: 'Your email address is invalid',
    },
    password: {
      name: 'password',
      label: 'Password',
      type: 'password',
      errorMsg: 'Password is required.',
      invalidMsg: 'Your password should be more than 6 characters.',
    },
    repeatPassword: {
      name: 'repeatPassword',
      label: 'Repeat Password',
      type: 'password',
      errorMsg: 'Password is required.',
      invalidMsg: "Your password doesn't match.",
    },
    playlist: {
      name: 'playlist',
      label: 'Playlist',
      type: 'text',
      invalidMsg: 'Playlist is invalid.',
      placeholder: 'Playlist',
    },
    isActive: {
      name: 'isActive',
      label: 'Active ',
      type: 'checkbox',
      errorMsg: 'Password is required.',
      invalidMsg: "Your password doesn't match.",
    },
    allowCustomPlaylists: {
      name: 'allowCustomPlaylists',
      label: 'Allow custom playlists',
      type: 'checkbox',
      errorMsg: 'Password is required.',
      invalidMsg: "Your password doesn't match.",
    },
    subscriptionDuration: {
      name: 'subscriptionDuration',
      label: 'Subscription Duration',
      type: 'select',
      errorMsg: 'Subscription duration is required.',
      invalidMsg: 'Please select a valid subscription duration.',
      options: [
        { id: '1', label: '1 Month' },
        { id: '3', label: '3 Months' },
        { id: '12', label: '1 Year' },
      ],
    },
  },
};

export default form;
